module.exports = "/to_the_arctic_for_practice/_next/static/videos/9-8ea2db2cd8932987b038797669c2292e.mp4";